angular.module('unergie.main')
.factory('PrmUtilsService', () => {
    const isLinky = function (metter_kind) {
        switch (metter_kind) {
            case 'AMM':
            case 'CCB':
            case 'LINKY':
                return true
            default:
                return false
        }
    }

    const isLinkyN2 = function (prm) {
        return prm.service_level === 2 && prm.teleoperable
    }

    const isMigratedLinky = function (prm) {
        return isLinky(prm.metter_kind) && (prm.service_level >= 2)
    }

    const getMinMaxPossiblePower = (prm) => {
        if (!prm.nb_wires || !prm.circuit_breaker_range || !prm.amperage) {
            return null
        }
        const coef = prm.nb_wires >= 4 ? 3 : 1
        const range = prm.circuit_breaker_range.split('-')
        const minCircuitBreaker = coef * Number(range[0]) * 0.2
        const maxCircuitBreaker = coef * Number(range.pop()) * 0.2
        const maxAvailablePower = (Number(prm.amperage.split('A')[0]) * coef) / 5

        return {
            min: minCircuitBreaker,
            max: Math.min(maxCircuitBreaker, maxAvailablePower),
            circuitBreaker: { min: minCircuitBreaker, max: maxCircuitBreaker },
            metter: maxAvailablePower,
        }
    }

    function isPrmValid(idPrm) {
        if (!idPrm || idPrm.length !== 14 || !/^[0-5,9][0-9]*$/.test(idPrm)) {
            return false
        }

        const n1 = Number(idPrm[3]) + Number(idPrm[4]) + Number(idPrm[5]) + Number(idPrm[6]) + Number(idPrm[7]) + Number(idPrm[8]) + Number(idPrm[9]) + Number(idPrm[10]) + Number(idPrm[11]) + 2
        const n2 = 2
            + (2 * Number(idPrm[11]))
            + (3 * Number(idPrm[10]))
            + (4 * Number(idPrm[9]))
            + (5 * Number(idPrm[8]))
            + (6 * Number(idPrm[7]))
            + (7 * Number(idPrm[6]))
            + (8 * Number(idPrm[5]))
            + (9 * Number(idPrm[4]))
            + (10 * Number(idPrm[3]))
        let mod1 = n1 % 11
        let mod2 = n2 % 11

        if (mod1 === 10 && mod2 === 10) { mod1 = 9; mod2 = 9 }
        else if (mod1 === 10 && mod2 === 0) { mod1 = 9; mod2 = 8 }
        else if (mod1 === 10 && mod2 !== 0) { mod1 = 0 }
        else if (mod1 === 0 && mod2 === 10) { mod1 = 8; mod2 = 9 }
        else if (mod1 !== 0 && mod2 === 10) { mod2 = 0 }

        return (idPrm[12] === mod1.toString() && idPrm[13] === mod2.toString())
    }

    function getPhasingForNbWires(nb_wires) {
        switch (nb_wires) {
            case 2:
            case 3: return 'MONOPHASE'
            case 4: return 'TRIPHASE'
            default:
        }
    }

    function getMaxDaysForPRMIntervention(prm) {
        return prm.distributor_it === 'GINKO' ? 120 : 42
    }

    return {
        isPrmValid,
        isMigratedLinky,
        isLinky,
        getMinMaxPossiblePower,
        isLinkyN2,
        getPhasingForNbWires,
        getMaxDaysForPRMIntervention,
    }
})
